// extracted by mini-css-extract-plugin
module.exports = {"brandSignal":"BrandSignal_brandSignal__Y4HXT"};